<template>
  <section>
    <v-toolbar color="#9190b5" dark src="https://picsum.photos/1920/1080?random">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(145,144,181,.7), rgba(25,32,72,.7)"></v-img>
      </template>
      <v-toolbar-title v-if="session" class="unselectable">{{ session.name }}</v-toolbar-title>
      <v-spacer/>
      <template v-slot:extension>
        <v-tabs centered class="blur">
          <v-tab :to="{name: 'Session info', params: $route.params}">Info</v-tab>
          <v-tab :to="{name: 'Session edit', params: $route.params}">Edit</v-tab>
          <v-tab :to="{name: 'Session response', params: $route.params}">Response</v-tab>
          <v-tab v-if="session && !session.parent_id" :to="{name: 'Session reschedule', params: $route.params}">Reschedule</v-tab>
          <v-tab v-if="session && !session.parent_id" :to="{name: 'Session children', params: $route.params}">Children</v-tab>
          <v-tab v-if="session && !session.parent_id" @click="delete_dialog = true">Delete</v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <router-view :session="session" @loadSession="loadSession"></router-view>

    <v-dialog v-model="delete_dialog" max-width="600px">
      <v-alert prominent type="error" :value="delete_dialog" max-width="600px" class="mb-0">
        <v-row align="center">
          <v-col class="grow">
            You want to delete the session. Tasks, grades and child sessions will also be removed. Are you sure?
          </v-col>
          <!--          <v-col class="shrink">-->
          <v-col class="shrink">
            <v-btn @click="deleteSession">Yes, delete!</v-btn>
          </v-col>
        </v-row>
      </v-alert>
    </v-dialog>


  </section>
</template>

<script>
export default {
  data: () => ({
    session: null,
    delete_dialog: false,
    api_errors: []
  }),
  // eslint-disable-next-line no-unused-vars
  beforeRouteEnter (to, from, next) {
    next(vm => vm.loadSession(to.params.session_id))
  },
  // eslint-disable-next-line no-unused-vars
  beforeRouteUpdate (to, from, next) {
    this.loadSession(to.params.session_id)
    next()
  },
  methods: {
    async loadSession(session_id = null) {
      this.app_loading = true
      let id = session_id ? session_id : this.$route.params.session_id
      await this.axios.get(`api/sessions/${id}`)
          .then(({data}) => {this.session = data.data})
          .catch(() => {})
          .then(() => {this.app_loading = false})
    },
    deleteSession() {
      this.app_loading = true
      this.axios.delete(`api/sessions/${this.$route.params.session_id}`)
          // .then(() => {this.$router.push({name: 'Sessions', params: this.$route.params})})
          .then(() => {this.$router.back()})
          .catch(() => {})
          .then(() => {this.app_loading = false})
    }
  }
}
</script>
